// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__ql0w6","label":"Category_label__2zl2s","content":"Category_content__KFH-T","header":"Category_header__2dBiO","location":"Category_location__1Zoht"};